import { useEffect, useRef } from 'react';
// eslint-disable-next-line no-use-before-define
import * as React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import cx from 'classnames';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import { useLocation } from 'react-router-dom';

import { RefValueSelector } from 'modules/core/components/selectors';
import { store } from '../../../lib/redux';
import * as actions from '../store/actions';
import APPConf from '../../../lib/config/common';
import { clientValidationSchema } from '../validation';
import { useComponentWillMount, useComponentDidUpdate } from '../../core/hooks';
import Can from '../../permissions/abilities/Can';
import { Button } from '../../core/components/buttons';
import { useMedia } from 'react-use';
import {
  Form,
  ResetButton,
  SubmitButton,
  StringInput,
  PhoneInput,
  DateTimeInput,
} from '../../core/components/forms';
import { dateUtils } from '../../core/utils';
import {
  SERVICE_68_TIRE_FITTING_STATIONARY,
  SERVICE_69_TIRE_STORAGE_STATIONARY, 
} from 'modules/core/constants/services';

const deleteClient = async (clientId) => {
  await store.dispatch(actions.deleteClient(clientId));
};

/* скелетон загружающихся данных в таблицу (список заявок, аваркомов и др) */
// Не удаляй комментарий ниже
// Заготовка для перехода на TS
// interface ClientFormProps {
//   initialValues?: object
//   clientId?: string
//   loading?: boolean
//   readOnly?: boolean
//   showFormActions?: boolean
//   onReset?(...args: unknown[]): unknown
//   onSubmit?(...args: unknown[]): unknown
//   data?: object
//   error?: object
//   getClientInfo?(...args: unknown[]): unknown
//   resetError?(...args: unknown[]): unknown
//   order?: object
//   shortMode?: boolean
//   // сокращённый режим формы фио, пол и Email
//   autoFocusLastName?: boolean
//   serviceId?: number
// }

// const ClientForm = React.forwardRef<HTMLElement, ClientFormProps>((props, ref) => {
const ClientForm = React.forwardRef<HTMLElement>((props, ref) => {  
  const {
    initialValues,
    clientId,
    loading = false,
    data,
    error,
    readOnly = false,
    showFormActions = true,
    getClientInfo,
    resetError,
    onReset,
    onSubmit,
    order,
    shortMode = false,
    autoFocusLastName = false,
    serviceId = -1,
  } = props;

  const disabled = loading || readOnly;
  const isMobile = useMedia('(max-width: 768px)');

  const errorInfo = error ? (
    <div>
      <p className='text-danger'>
        <strong>{ error.message }</strong>
      </p>
      <p className='text-danger'>
        <strong>{ APPConf.error_to_email_text }</strong>
      </p>
    </div>
  ) : null;

  const location = useLocation();

  const lastNameRequired = !(location?.pathname.indexOf('scheduler') >= 0);

  const clientInput = useRef(null);

  useEffect(() => {
    if (autoFocusLastName && clientInput) {
      clientInput?.current?.focus();
    }
  }, []);

  const saveClient = async (values, form) => {
    // @see https://github.com/jaredpalmer/formik/issues/473
    const castValues = clientValidationSchema(lastNameRequired && !isMobile).cast(values);
    try {
      if (!values?.id) {
        await store.dispatch(actions.createClient(castValues));
      } else {
        await store.dispatch(actions.updateClient(castValues));
      }
    } catch (errorObj) {
      form.setErrors(errorObj);
      throw errorObj;
    } finally {
      form.setSubmitting(false);
    }
  };

  useComponentWillMount(() => {
    resetError();
  });

  useComponentDidUpdate(() => {
    if (!isEmpty(data) && !error && !loading && (typeof onSubmit === 'function')) {
      onSubmit(data);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading, data]);
  // До 21.04.2025 тут было так:
  // }, [loading, error, data]);
  // Удалил error, чтоб из новой формы эвакуации работало корректно

  useEffect(() => {
    if ((clientId) && (data?.id !== clientId)) {
      getClientInfo(clientId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId, getClientInfo]);

  return (
    <Form
      ref={ ref }
      initialValues={ { ...initialValues, ...data, forOrderId: order?.id } }
      validationSchema={ clientValidationSchema(lastNameRequired && !isMobile) }
      onReset={ onReset }
      onSubmit={ saveClient }
      enableReinitialize
    >
      { ({ values }) => (
        <>
          <Row>
            <Col lg={ 12 }>{ errorInfo }</Col>
          </Row>

          { !shortMode
            && (
              <Row>
                <Col lg={ 12 }>
                  <Row>
                    <Col md={ 4 }>
                      <PhoneInput
                        name='phoneNumber'
                        label='Телефон'
                        placeholder='Телефон'
                        disabled={ true }
                      />
                    </Col>
                    { !isMobile && <Col md={ 4 }>
                      <RefValueSelector
                        name='statusRefValueId'
                        refId='27'
                        label='Статус в системе'
                        placeholder='Статус в системе'
                        disabled
                        className={ cx({ 'text-danger': data?.isBlocked }) }
                      />
                    </Col> }
                    { !isMobile && <Col md={ 4 }>
                      <DateTimeInput
                        name='createdDate'
                        label='Дата регистрации в системе'
                        placeholder='Дата'
                        displayFormat='dd.MM.yyyy hh:mm'
                        readOnly
                      />
                    </Col>
                    }
                  </Row>
                </Col>
              </Row>
            ) }

          <Row>
            <Col lg={ 12 }>
              <Row>
                <Col md={ 4 }>
                  <StringInput
                    ref={ clientInput }
                    name='lastName'
                    label='Фамилия'
                    placeholder='Фамилия'
                    disabled={ disabled }
                  />
                </Col>
                <Col md={ 4 }>
                  <StringInput name='firstName' label='Имя' placeholder='Имя' disabled={ disabled } />
                </Col>

                { !(isMobile 
                  && [SERVICE_68_TIRE_FITTING_STATIONARY, SERVICE_69_TIRE_STORAGE_STATIONARY].includes(serviceId)) &&
                  <Col md={ 4 }>
                    <StringInput name='middleName' label='Отчество' placeholder='Отчество' disabled={ disabled } />
                  </Col>
                }
              </Row>
            </Col>
          </Row>

          <Row>
            <Col lg={ 12 }>
              <Row>
                { shortMode && ([68, 69].includes(serviceId)) && (
                  <Col md={ 4 }>
                    <PhoneInput
                      name='phoneNumber'
                      label='Телефон'
                      placeholder='Телефон'
                      disabled={ disabled }
                    />
                  </Col>
                ) }
                <Col md={ 4 }>
                  <Can do='available' on='reference.client.email' passThrough>
                    { can => (
                      <StringInput
                        name='email'
                        label='Email'
                        placeholder='Email'
                        disabled={ disabled || (!can && !!data.id && !!data.email) }
                      />
                    ) }
                  </Can>
                </Col>
                { !shortMode && !isMobile
                  && (
                    <>
                      <Col md={ 4 }>
                        <PhoneInput
                          name='contactPhoneNumber1'
                          label='Контактный Телефон 1'
                          placeholder='Контактный Телефон 1'
                          disabled={ disabled }
                        />
                      </Col>
                      <Col md={ 4 }>
                        <PhoneInput
                          name='contactPhoneNumber2'
                          label='Контактный Телефон 2'
                          placeholder='Контактный Телефон 2'
                          disabled={ disabled }
                        />
                      </Col>
                    </>
                  ) }
                { /* { shortMode && !(isMobile && [68,69].includes(serviceId)) && (
                  <Col md={ 3 }>
                    <RefValueSelector
                      name='genderRefValueId'
                      refId={ 52 }
                      label='Пол'
                      placeholder='Пол'
                      disabled={ disabled }
                    />
                  </Col>
                ) } */ }
              </Row>
            </Col>
          </Row>

          { !shortMode && !isMobile
            && (
              <Row>
                <Col lg={ 12 }>
                  <StringInput name='address' label='Адрес' placeholder='Адрес' disabled={ disabled } />
                </Col>
              </Row>
            ) }

          { !shortMode
            && !(isMobile && [68, 69].includes(serviceId)) && (
            <Row>
              <Col md={ 3 }>
                <DateTimeInput
                  name='dateOfBirth'
                  label='Дата рождения'
                  placeholder='Дата рождения'
                  displayFormat='dd.MM.yyyy'
                  serverFormat='yyyy-MM-dd'
                  showTime={ false }
                  minDate={ dateUtils.yearsAgo(100) }
                  disabled={ disabled }
                />
              </Col>
              <Col md={ 3 }>
                <RefValueSelector
                  name='genderRefValueId'
                  refId={ 52 }
                  label='Пол'
                  placeholder='Пол'
                  disabled={ disabled }
                />
              </Col>
            </Row>
          ) }

          { !shortMode

            && (
              <Row className='mb-2'>
                <Col lg={ 12 } style={ { minHeight: 24 } }>
                  { !readOnly && (
                    <small className='text-danger'>Поля, помеченные *, обязательны для заполнения</small>
                  ) }
                </Col>
              </Row>
            ) }

          { !readOnly && showFormActions && (
            <Row>
              <Col lg={ 12 }>
                { values.id && (
                  <ButtonToolbar className='float-start'>
                    <Can do='permissionDelete' on='order.client' passThrough>
                      { can => (
                        <Button
                          variant='danger'
                          text='Удалить'
                          disabled={ !can || loading }
                          onClick={ () => deleteClient(values.id) }
                        />
                      ) }
                    </Can>
                  </ButtonToolbar>
                ) }

                <ButtonToolbar className='float-end'>
                  <ResetButton text='Отмена' />

                  <Can do={ ['permissionInsert', 'permissionUpdate'] } on='order.client' passThrough>
                    { can => (
                      <SubmitButton text='Сохранить' disabled={ !can } />
                    ) }
                  </Can>
                </ButtonToolbar>
              </Col>
            </Row>
          ) }
        </>
      ) }
    </Form>
  );
});

const mapStateToProps = (state) => {
  return {
    loading: state.clients?.loading,
    data: state.clients?.item,
    error: state.clients?.error,
    order: state.orders.item,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getClientInfo: payload => dispatch(actions.getClientInfo(payload)),
    resetError: payload => dispatch(actions.resetError(payload)),
  };
};

const options = { forwardRef: true };

export default connect(mapStateToProps, mapDispatchToProps, null, options)(ClientForm);
